import { useDeferredValue, useEffect, useState } from "react";

import { useGetContacts } from "app/pages/sales-intelligence/modules/ai-agent/queries/useGetContacts";
import type { Contact } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";

type Props = {
    value: Contact | null;
    onChange: (value: Contact | null) => void;
    domain: string;
};

const CONTACTS_LIMIT = 16;

export const useRecipients = ({ value, onChange, domain }: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const [inputValue, setInputValue] = useState("");
    const deferredSearch = useDeferredValue(inputValue);

    const onSearchChange = (val: string) => {
        setInputValue(val);
    };

    const { data, isFetched, isLoading } = useGetContacts({ domain, search: deferredSearch, limit: CONTACTS_LIMIT });

    useEffect(() => {
        if (data?.length && data.length > 0 && !value) {
            setIsOpen(true);
        }
    }, [data, value]);

    useEffect(() => {
        setInputValue("");
    }, [domain]);

    const onSelectContact = (contact: Contact) => {
        onChange(contact);
        setInputValue("");
        setIsOpen(false);
    };

    const onClear = () => {
        onChange(null);
        setInputValue("");
        setIsOpen(false);
    };

    return {
        isOpen,
        inputValue,
        search: deferredSearch,
        data,
        isFetched,
        isLoading,
        onSearchChange,
        setInputValue,
        onSelectContact,
        onClear,
        setIsOpen,
    };
};
